export const dublinCoordinates: Record<string, { lat: number; lng: number }> = {
  'Exchequer Street, Creative Quarter': { lat: 53.3422, lng: -6.2637 },
  'Trinity College Dublin': { lat: 53.3438, lng: -6.2546 },
  "St Stephen's Green": { lat: 53.3382, lng: -6.2591 },
  'Merrion Square West': { lat: 53.3395, lng: -6.2488 },
  'Drury Street': { lat: 53.3424, lng: -6.2628 },
  'Chatham Street': { lat: 53.3413, lng: -6.2612 },
  'South William Street': { lat: 53.3415, lng: -6.2637 },
  'Phoenix Park': { lat: 53.3559, lng: -6.3298 },
  'Inchicore Road, Kilmainham': { lat: 53.342, lng: -6.31 },
  'Royal Hospital Kilmainham': { lat: 53.3413, lng: -6.3095 },
  "St. James's Gate Brewery": { lat: 53.3419, lng: -6.2868 },
  "South Great George's Street": { lat: 53.3416, lng: -6.2659 },
  'Bow Street, Smithfield': { lat: 53.3479, lng: -6.2775 },
  'Dame Street': { lat: 53.3436, lng: -6.2674 },
  'Dublin Castle grounds': { lat: 53.3432, lng: -6.2674 },
  'Temple Bar': { lat: 53.3455, lng: -6.2642 },
  'Merrion Row': { lat: 53.3391, lng: -6.2537 },
  'City Centre': { lat: 53.344, lng: -6.267 },
  "O'Connell Street area": { lat: 53.3498, lng: -6.2603 },
  'Grafton Street / South William Street': { lat: 53.3412, lng: -6.2611 },
  'Various locations': { lat: 53.343, lng: -6.26 },
  'Grafton Street': { lat: 53.3408, lng: -6.2603 },
  'Exchequer Street': { lat: 53.3422, lng: -6.2637 },
  'Merrion Square': { lat: 53.3395, lng: -6.2488 },
  'Essex Street East, Temple Bar': { lat: 53.3455, lng: -6.2665 },
  'Dawson Street': { lat: 53.3413, lng: -6.2588 },
  'South Anne Street': { lat: 53.3417, lng: -6.2598 },
  'Dublin Airport': { lat: 53.4264, lng: -6.2499 },
  'Capel Street': { lat: 53.3473, lng: -6.2657 },
  'Custom House Quay': { lat: 53.3477, lng: -6.2519 },
  'Christchurch Place': { lat: 53.3434, lng: -6.2715 },
  'Lower Bridge Street': { lat: 53.3445, lng: -6.2723 },
  'Parliament Street': { lat: 53.3445, lng: -6.268 },
  'Moore Street': { lat: 53.3506, lng: -6.2613 },
  'Aungier Street': { lat: 53.3389, lng: -6.2649 },
  'Wicklow Street': { lat: 53.3424, lng: -6.2615 },
  'Francis Street': { lat: 53.3404, lng: -6.2747 },
  'Kildare Street': { lat: 53.3411, lng: -6.2541 },

  // Roadtrip — west coast
  'Athlone, Westmeath': { lat: 53.4233, lng: -7.9406 },
  'Latin Quarter, Galway': { lat: 53.272, lng: -9.0532 },
  'Sea Road, Galway': { lat: 53.2706, lng: -9.06 },
  'Mainguard Street, Galway': { lat: 53.2723, lng: -9.0533 },
  'Shop Street, Galway': { lat: 53.2718, lng: -9.0527 },
  'Spanish Arch, Galway': { lat: 53.2697, lng: -9.0537 },
  'Spanish Parade, Galway': { lat: 53.2697, lng: -9.0541 },
  'Church Lane, Galway': { lat: 53.2724, lng: -9.0533 },
  'Gaol Road, Galway': { lat: 53.2745, lng: -9.0599 },
  'Claddagh, Galway': { lat: 53.2682, lng: -9.057 },
  'Quay Street, Galway': { lat: 53.271, lng: -9.0531 },
  'Middle Street, Galway': { lat: 53.2719, lng: -9.0524 },
  'Lombard Street, Galway': { lat: 53.2727, lng: -9.054 },
  'Eyre Square, Galway': { lat: 53.2742, lng: -9.0521 },
  'Salthill, Galway': { lat: 53.2613, lng: -9.0815 },
  'Mutton Island Causeway, Galway': { lat: 53.266, lng: -9.064 },
  'Kinvara, Co. Galway': { lat: 53.138, lng: -8.9362 },
  'Burren National Park': { lat: 53.0017, lng: -9.04 },
  'Cliffs of Moher': { lat: 52.9715, lng: -9.4309 },
  'Doolin, Co. Clare': { lat: 53.0167, lng: -9.3783 },
};

export const dublinCenter = { lat: 53.344, lng: -6.267 };
